import { apiFetch } from './client.js';
import type { AuditOverride } from './cases.js';

export interface ShaftDispute {
  id: string;
  caseId: string;
  contentType: string;
  details: string;
  status: string;
  flaggedAt: string;
  oaNotifiedRegistrantAt: string | null;
  oaNotifyDeadline: string | null;
  registrantResponseDeadline: string | null;
  registrantResponse: string | null;
  registrantResponseAt: string | null;
  modificationContent: string;
  bcidReviewDeadline: string | null;
  finalDetermination: string | null;
  finalDeterminationAt: string | null;
}

export interface IpDispute {
  id: string;
  caseId: string;
  type: string;
  status: string;
  receivedAt: string;
  claimantName: string;
  claimantEmail: string;
  claimantPhone: string;
  claimantAddress: string;
  claimDetails: string;
  trademarkRegNumber: string;
  trademarkSerialNumber: string;
  trademarkIc: string;
  trademarkOwner: string;
  registrantNotifiedAt: string | null;
  notifyDeadline: string | null;
  contentSuspendedAt: string | null;
  suspendDeadline: string | null;
  registrantResponseDeadline: string | null;
  registrantResponse: string | null;
  registrantResponseAt: string | null;
  counterClaimDetails: string;
  reinstateEarliestDate: string | null;
  reinstateLatestDate: string | null;
  courtActionFiled: boolean;
  resolutionMethod: string | null;
  reviewBoardConvenedAt: string | null;
  reviewBoardDeadline: string | null;
  finalDetermination: string | null;
  finalDeterminationAt: string | null;
  settlementPlatformNotifiedAt: string | null;
}

export async function openShaftDispute(
  caseId: string,
  body: { contentType: string; details: string; action?: AuditOverride },
  idempotencyKey: string,
): Promise<ShaftDispute> {
  return apiFetch<ShaftDispute>(`/cases/${caseId}/disputes/shaft`, {
    method: 'POST',
    headers: { 'Idempotency-Key': idempotencyKey },
    body: JSON.stringify(body),
  });
}

export async function patchShaftDispute(
  caseId: string,
  disputeId: string,
  patch: Partial<ShaftDispute> & { action?: AuditOverride },
): Promise<ShaftDispute> {
  return apiFetch<ShaftDispute>(`/cases/${caseId}/disputes/shaft/${disputeId}`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
}

export async function openIpDispute(
  caseId: string,
  body: { type: string; claimantName?: string; claimantEmail?: string; claimDetails?: string; action?: AuditOverride },
  idempotencyKey: string,
): Promise<IpDispute> {
  return apiFetch<IpDispute>(`/cases/${caseId}/disputes/ip`, {
    method: 'POST',
    headers: { 'Idempotency-Key': idempotencyKey },
    body: JSON.stringify(body),
  });
}

export async function patchIpDispute(
  caseId: string,
  disputeId: string,
  patch: Partial<IpDispute> & { action?: AuditOverride },
): Promise<IpDispute> {
  return apiFetch<IpDispute>(`/cases/${caseId}/disputes/ip/${disputeId}`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
}
